import React from "react";
import { Star, ChevronRight } from "lucide-react";
import { Card } from "@/components/ui/card";

export default function CompanyCard({ company }) {
  const getInitials = (name) => name.substring(0, 2).toUpperCase();

  const getRandomColor = () => {
    const colors = [
      "bg-blue-100 text-blue-600",
      "bg-green-100 text-green-600",
      "bg-purple-100 text-purple-600",
      "bg-orange-100 text-orange-600",
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  return (
    <Card className="p-4 rounded-2xl border border-gray-100 hover:shadow-lg transition cursor-pointer group">
      <div className="flex items-start gap-4">

        {/* Logo */}
        <div
          className={`w-14 h-14 rounded-lg flex items-center justify-center text-lg font-bold ${
            company.logo_url ? "" : getRandomColor()
          }`}
        >
          {company.logo_url ? (
            <img
              src={company.logo_url}
              alt={company.name}
              className="w-full h-full object-contain rounded-lg"
            />
          ) : (
            getInitials(company.name)
          )}
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-start">
            <div>
              <h3 className="font-bold text-gray-900 text-lg truncate group-hover:text-[#2557a7]">
                {company.name}
              </h3>

              <div className="flex items-center gap-2 mt-1 mb-2">
                <div className="flex items-center gap-1">
                  <Star className="w-3.5 h-3.5 text-[#f5c242] fill-[#f5c242]" />
                  <span className="font-bold text-sm text-[#f5c242]">
                    {company.rating}
                  </span>
                </div>

                <div className="h-3 w-[1px] bg-gray-300" />

                <span className="text-gray-500 text-xs">
                  {company.reviews_count} reviews
                </span>
              </div>
            </div>

            {/* Arrow */}
            <div className="bg-gray-50 p-1.5 rounded-full opacity-0 group-hover:opacity-100 transition">
              <ChevronRight className="w-5 h-5 text-gray-400" />
            </div>
          </div>

          {/* Tags */}
          <div className="flex flex-wrap gap-2 mt-1">
            {company.tags?.map((tag, idx) => (
              <span
                key={idx}
                className="px-2 py-0.5 text-xs text-gray-500 border border-gray-200 rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

      </div>
    </Card>
  );
}
